import * as ActionTypes from '../ActionTypes';

export const GetOfferLetterIDAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_OFFER_LETTER_ID_GET_REQUEST,
        params,
        callback
    };
};

export const UpdateOfferLetterIDAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_OFFER_LETTER_ID_UPDATE_REQUEST,
        params,
        callback
    };
};
